
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5c17f374!sass-loader?{\"api\":\"modern\",\"sassOptions\":{\"quietDeps\":true},\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./trendingCharts.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./trendingCharts.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5c17f374!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./trendingCharts.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/studentActivitySummary/components/trendingCharts.vue
// module id = 1692
// module chunks = 61